import { useQuery } from '@tanstack/react-query'

import memeService from '@/services/meme.service'

import type { MemePost } from '@/types/meme.interface'

interface UseTrendingPostsOptions {
  limit?: number
  enabled?: boolean
}

export function useTrendingPosts(options: UseTrendingPostsOptions = {}) {
  const { limit = 10, enabled = true } = options

  return useQuery<MemePost[]>({
    queryKey: ['trending-posts', limit],
    queryFn: () => memeService.getTrendingPosts(limit),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
